import { useQuery } from "react-query";
import { useAccessToken } from "hooks/useAccessToken";
import { QUERY_STALE_TIME } from "utils/constants";
import queryFn from "ApiLayer/BuildingReports/Project/queryTotalCarbonEmissionsCard";

export const useTotalCarbonEmissionsCard = (carbonReductionMeasureUid: string) => {
    const accessToken = useAccessToken();

    return useQuery({
        queryKey: ["buildingModelReport", "projectReportTotalAnnualEmissionsCard", carbonReductionMeasureUid],
        queryFn: async () => queryFn(accessToken, carbonReductionMeasureUid),
        staleTime: QUERY_STALE_TIME,
    });
};
